import React from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Header, Wrapper } from '../../components_renew/Layout'
import imgBg1 from '../../assets/events/new_year_event/bg_01.jpg'
import imgBg2 from '../../assets/events/new_year_event/bg_02.jpg'
import imgBg3 from '../../assets/events/new_year_event/bg_03.jpg'
import imgBg4 from '../../assets/events/new_year_event/bg_04.jpg'
import imgCard1 from '../../assets/events/new_year_event/card_01.png'
import imgCard2 from '../../assets/events/new_year_event/card_02.png'
import imgCard3 from '../../assets/events/new_year_event/card_03.png'
import imgCard4 from '../../assets/events/new_year_event/card_04.png'
import api from '../../api'
import { handleCatch, postMessage } from '../../utils'

@withRouter
class NewYearEvent extends React.PureComponent {
  state = {
    amount: 0,
    cumulativeMoney: 0,
    predictGiveIntegral: 0,
    success: false,
  }

  componentDidMount () {
    document.title = '元旦乐翻天'
    window.toast.loading()
    api.integral.fetchUserCumulativeMoneyToday()
      .then(res => {
        window.toast.hide()
        this.setState({ success: true })
        if (res) {
          this.setState({
            cumulativeMoney: res['cumulativeMoney'],
            predictGiveIntegral: res['predictGiveIntegral'],
            amount: Number((res['predictGiveIntegral'] / 10).toFixed(1))
          })
        }
      })
      .catch(handleCatch)
  }

  render () {
    const { withHeader } = this.props
    const { amount, cumulativeMoney, predictGiveIntegral } = this.state
    return <Container>
      {withHeader ? <Header>活动</Header> : null}
      <Wrapper>
        <img className='events-bg' src={imgBg1} alt=''/>
        <div className={'events-card'} style={{ padding: '0 2rem' }}>
          <div className={'events-card__content'} style={{ width: 300 }}>
            <img className={'events-card__item'} src={imgCard1} alt=''/>
            <div className={'events-card__text events-card--primary'}
                 style={{ fontSize: 10, color: '#ea3105' }}>将领取 {predictGiveIntegral} 积分
            </div>
            <img className={'events-card__item'} src={imgCard2} alt=''/>
            <div className={'events-card__text events-card--primary'}
                 style={{ fontWeight: 'bold', color: '#fff2a4' }}>可兑换 {amount} 元现金券
            </div>
            <img className={'events-card__item'} src={imgCard3} alt=''/>
            <div className={'events-card__text'}
                 style={{ color: 'white',fontSize: 10}}>
              今日订单总金额：{cumulativeMoney} 元
            </div>
            <img className={'events-card__item'} src={imgCard4} alt=''/>
          </div>
        </div>
        <img className='events-bg' src={imgBg2} alt=''/>
        <img className='events-bg' src={imgBg3} alt='' onClick={this.goToBuy}/>
        <img className='events-bg' src={imgBg4} alt=''/>
      </Wrapper>
    </Container>
  }

  onBtnClick = () => {
    postMessage({
      type: window.POST_TYPE.INTEGRAL
      // type: 'integral'
    })
  }

  goToBuy = () => {
    postMessage({
      type: window.POST_TYPE.BUY
    })
  }
}

export default NewYearEvent
